export default "__VITE_ASSET__B5CRapAk__"